import { sendGAEvent } from '@next/third-parties/google';
import { useCallback } from 'react';

import { useAppSelector } from '@/store/utils';

export const useGA = () => {
  const { projectInfo } = useAppSelector(state => state.project);

  const trackGAEvent = useCallback(
    ({ category, action, label, value, fields }: any) => {
      if (!projectInfo || !projectInfo.info.gAnalyticId) return;

      sendGAEvent('event', action, {
        event_category: category,
        event_label: label,
        value,
        ...fields, // Spread operator to include additional fields
      });
    },
    [projectInfo],
  );

  const trackButtonClickEvent = useCallback(
    ({ name, address }: any) => {
      if (!projectInfo || !projectInfo.info.gAnalyticId) return;

      trackGAEvent({
        action: `${name}_button_click`,
        label: `${name} button click`,
        fields: {
          address,
        },
      });
    },
    [projectInfo, trackGAEvent],
  );

  return {
    trackGAEvent,
    trackButtonClickEvent,
  };
};
